module.exports = __webpack_public_path__ + "img/fire.5a6c7df5.png";